<div class="auth-sub-component">
  <p class="request-instructions"> Enter your email to activate your account</p>
  <nz-spin nzTip='Checking...' [nzSpinning]="loading" [nzSize]="'large'">
    <form nz-form nzLayout="vertical" [formGroup]="form" (ngSubmit)="onSubmit()">
      <nz-form-item [ngClass]="{'has-error':f.email.dirty && f.email.errors, 'has-value':f.email.value}">
        <nz-form-label [nzRequired]="true">Email address</nz-form-label>
        <nz-form-control [nzErrorTip]="emailValidationsTpl">
          <ng-template #emailValidationsTpl>
            <ng-container *ngIf="f.email?.dirty &&  f.email.errors && f.email.errors.required">
              Email is required
            </ng-container>
            <ng-container *ngIf="f.email?.dirty &&  f.email.errors && f.email.errors.email">
              Email is not valid
            </ng-container>
          </ng-template>

          <nz-input-group [nzPrefix]="prefixUser" nzSize="large">
            <input type="text" nz-input formControlName="email" name="email" id="email" placeholder="Enter your email">
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <app-captcha [form]="form"
                   (resolved)="captchaResolved($event)">
      </app-captcha>

      <nz-form-item class="margin-bottom-regular">
        <nz-form-control>
          <button [nzLoading]="loading"
                  class="primary-button"
                  [disabled]="!form.valid"
                  nz-button nzSize="large" nzType="primary" nzBlock id="submit">Send
          </button>
        </nz-form-control>
      </nz-form-item>

    </form>

    <ng-template #prefixUser><em nz-icon nzType="user"></em></ng-template>
  </nz-spin>
</div>
